import { LocalStorageFacade } from 'paliari-js-utils'
import toastErrors from '@/lib/errors/toastErrors'
import api from '@/api/fiscalizacao/docs'
import Doc from '@/models/Doc'

export default {
  props: { docTipo: String, id: [Number, String] },
  data() {
    return {
      localStorageSteps: [],
      loading: false,
      resource: null,
    }
  },
  methods: {
    setResource(resource) {
      this.$set(this, 'resource', resource)
    },
  },
  computed: {
    steps() {
      return this.localStorageSteps
        .map(name =>
          this.mapRoutes[name] ? { ...this.mapRoutes[name], name } : null,
        )
        .filter(route => Boolean(route))
    },
  },
  async created() {
    try {
      this.loading = true
      let doc = LocalStorageFacade.getItem('doc')
      if (!doc || !doc.id) {
        doc = await api.edit(this.id)
      }
      if (!doc.permite_editar) doc.comentarios = []
      this.setResource(new Doc(doc))
      LocalStorageFacade.setItem('doc', this.resource)
      LocalStorageFacade.setItem(
        'steps',
        this.resource.modelo.params.osm.steps.web,
      )
      this.localStorageSteps = LocalStorageFacade.getItem('steps')
    } catch (e) {
      toastErrors(e)
    } finally {
      this.loading = false
    }
  },
  destroyed() {
    LocalStorageFacade.removeItem('doc')
    LocalStorageFacade.removeItem('steps')
    this.setResource(null)
  },
}
